var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["boss-table-2-layout", { "boss-table-2-layout-half": _vm.half }],
      attrs: { "data-test": "layout" },
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-table-2-item boss-table-2-item-head",
          attrs: { "data-test": "label" },
        },
        [
          _vm._t("before-label"),
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _vm.isRequired
            ? _c("span", { staticClass: "label alert" }, [_vm._v("必須")])
            : _vm._e(),
          _vm._v(" "),
          _vm.explanation
            ? _c(
                "div",
                {
                  staticClass: "boss-annotation-text",
                  attrs: { "data-test": "explanation" },
                },
                [_vm._v("\n      " + _vm._s(_vm.explanation) + "\n    ")]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "width-100",
          class: [
            "boss-table-2-item",
            "boss-table-2-item-body",
            { "boss-table-2-item-body-has-child": _vm.hasChild },
            { "is-modified": _vm.isModified },
          ],
          attrs: { "data-test": "body" },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }